import OwaUserConfiguration from '../contract/OwaUserConfiguration';
import type OwaViewStateConfiguration from '../contract/OwaViewStateConfiguration';
import type SessionSettingsType from '../contract/SessionSettingsType';
import type UserOptionsType from '../contract/UserOptionsType';
import type RecursiveReadOnly from '../RecursiveReadOnly';

// To move an entire property from OwaUserConfiguration into AccountScopeUserSettings, add it to this property list.
export const accountScopeOwaUserConfigurationProperties = [
    'Favorites',
    'MasterCategoryList',
] as const;
export type AccountScopeOwaUserConfigurationKeys = typeof accountScopeOwaUserConfigurationProperties[number];

// To move a property from OwaUserConfiguration.SessionSettings to AccountScoperUserSettings.SessionSettings, add it to this property list.
export const accountScopeSessionSettingsProperties = [] as const;
export type AccountScopeSessionSettingsKeys = typeof accountScopeSessionSettingsProperties[number];

// To move a property from OwaUserConfiguration.UserOptions to AccountScoperUserSettings.UserOptions, add it to this property list.
export const accountScopeUserOptionsProperties = [] as const;
export type AccountScopeUserOptionsKeys = typeof accountScopeUserOptionsProperties[number];

// To move a property from OwaUserConfiguration.ViewStateConfiguration to AccountScoperUserSettings.ViewStateConfiguration, add it to this property list.
export const accountScopeViewStateConfigurationProperties = [] as const;
export type AccountScopeViewStateConfigurationKeys = typeof accountScopeViewStateConfigurationProperties[number];

// Here we use the parameterizations above to build the AccountScopeUserSettings type from OwaUserConfiguration.
export type AccountScopeUserSettings = Pick<
    OwaUserConfiguration,
    AccountScopeOwaUserConfigurationKeys
> & {
    SessionSettings: Pick<SessionSettingsType, AccountScopeSessionSettingsKeys>;
    UserOptions: Pick<UserOptionsType, AccountScopeUserOptionsKeys>;
    ViewStateConfiguration: Pick<OwaViewStateConfiguration, AccountScopeViewStateConfigurationKeys>;

    defaultFolderNameToIdMap: Map<string, string>;

    // This map feeds the data into the defaultFolderIdToNameMap on session store.
    // Keeping it here as well to remove the entries from the global map when an account is deleted.
    defaultFolderIdToNameMap: Map<string, string>;
};
export type ReadOnlyAccountScopeUserSettings = RecursiveReadOnly<AccountScopeUserSettings>;
